import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NameIdPair } from '../interfaces/name-id-pair.interface';
import { LinkTransferPreview } from '../interfaces/link-transfer-preview.interface';
import { LinkTransferRequestModel } from '../interfaces/link-transfer-request-model.interface';
import { LinkTransferSerializerOptions } from '../interfaces/link-transfer-serialization-options.interface';
import { LinkTransferDeserializerOptions } from '../interfaces/link-transfer-deserialization-options.interface';
import { EnrichedLinkTransferRequestModel } from '../interfaces/link-transfer-request-model.interface';

@Injectable({
	providedIn: 'root',
})
export class LinkTransferService {
	url: string = 'linkTransfer';

	constructor(private http: HttpClient) {}

	public getSelectableAL2Users() {
		return this.http.get<NameIdPair[]>(`${this.url}/GetSelectableAL2Users`);
	}

	public getSelectableAL3Companies(sourceSystem: string) {
		return this.http.get<NameIdPair[]>(`${this.url}/GetSelectableAL3Companies/${sourceSystem}`);
	}

	public getAL2UserDomainPreview(userId: number) {
		return this.http.get<LinkTransferPreview[]>(`${this.url}/GetAL2UserDomainPreview/${userId}`);
	}

	public getDomainCompanyPreview(companyId: number, sourceSystem: string) {
		return this.http.get<LinkTransferPreview[]>(`${this.url}/getDomainCompanyPreview/${sourceSystem}/${companyId}`);
	}

	public prepareLinkTransferRequest(model: LinkTransferRequestModel) {
		return this.http.post<EnrichedLinkTransferRequestModel>(`${this.url}/PrepareLinkTransferRequest`, model);
	}

	public transferLinks(model: LinkTransferRequestModel) {
		return this.http.post<any[]>(`${this.url}/TransferLinks`, model);
	}

	public updatePurchaseOrderCache() {
		return this.http.post<any[]>(`${this.url}/UpdatePurchaseOrderCache`, {});
	}

	public getLinkTransferCode(linkTransferSerializerOptions: LinkTransferSerializerOptions) {
		return this.http.post<string>(`${this.url}/GetUniqueLinkTransferCode`, linkTransferSerializerOptions, { responseType: 'text' as 'json' });
	}

	public updateLinkUsingTransferCode(linkTransferDeserializerOptions: LinkTransferDeserializerOptions) {
		return this.http.post<string>(`${this.url}/UpdateLinkUniqueLinkTransferCode`, linkTransferDeserializerOptions);
	}

	public getLinkTransferCodePreview(encryptedText: string) {
		return this.http.post<string>(`${this.url}/GetLinkTransferCodePreview`, encryptedText);
	}
}
